import OneSignal from 'react-onesignal';

export const toggleOneSignalPrompt = () => {
  console.debug('toggleOneSignalPrompt');
  OneSignal.Slidedown.promptPush()
    .then((response) => console.debug('reponse', response))
    .catch((error) => console.error('error', error));
};
